<div class="conatiner-fluid">
    <div class="row">
        <div class="col-2">
            <h2><b>Allocation History</b></h2>
        </div>
        <div class="col-10">
            <div class="card" style="padding: 10px;">
                <div class="form-row">
                    <div class="form-group col-12">
                        <label for="">BANK NAME</label>
                        <select [(ngModel)]="bankid" class="form-control">
                            <option *ngFor="let item of bankList" [value]="item._id">{{item.bank_name}}</option>
                        </select>
                    </div>
                    <div class="form-group col-12">
                        <label for="">POTFOLIO NAME</label>
                        <select [(ngModel)]="portfolioid" class="form-control">
                            <option *ngFor="let item of portfolioList" [value]="item._id">{{item.portfolio_type}}</option>
                        </select>
                    </div>
                    <div class="form-group col-12">
                        <label for="">BUCKET ID</label>
                        <select [(ngModel)]="bucketid" class="form-control">
                            <option *ngFor="let item of bucketList" [value]="item._id">{{item._id}}</option>
                        </select>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="row" style="text-align: right;">
        <div class="col-12" style="text-align: right;">
            <button class="btn btn-sm btn-dark mr-1 mt-1 mb-1" (click)="search()">Search</button>
        </div>
    </div>
</div>

<div class="conatiner-fluid">
    <div class="row">
        <div class="col-12">

        </div>
    </div>
</div>